import React, {Component, PropTypes} from 'react'
import ReactDOM from 'react-dom'

const CHROME_PASSWORD_AUTOCOMPLETE_PLACEHOLDER = 'ChromePasswordAuthocompletePlaceholder'

export function autocompletePasswordInputField(field) {
    function onChange(event) {
        if (isChromePasswordAutocompleteInitial(event.target)) {
            field.onChange(CHROME_PASSWORD_AUTOCOMPLETE_PLACEHOLDER)
            return
        }
        field.onChange(event)
    }

    if (field.value == CHROME_PASSWORD_AUTOCOMPLETE_PLACEHOLDER) return {onChange}
    return {...field, onChange}
}

function isChromePasswordAutocompleteInitial(element) {
    return element.type == 'password' && getComputedStyle(element).backgroundColor == 'rgb(250, 255, 189)' && !element.value
}

class Autocomplete extends Component {
    static propTypes = {
    }

    componentDidMount() {
        const element = ReactDOM.findDOMNode(this)
        this._inputElements = [...element.querySelectorAll('input')]
        this._inputValues = this._inputElements.map((e) => e.value)

        element.addEventListener('input', (event) => {
            this._inputChanged(event.target)
            
            clearTimeout(this._timer)
            this._timer = setTimeout(() => this._dispatchMissingInputEvents(), 200)
        })
    }

    componentWillUnmount() {
        clearTimeout(this._timer)
    }

    _dispatchMissingInputEvents() {
        for (var i = 0 ; i < this._inputElements.length ; i++) {
            if (isChromePasswordAutocompleteInitial(this._inputElements[i])) {
                // Chrome password input specific
                if (this._inputValues[i] != CHROME_PASSWORD_AUTOCOMPLETE_PLACEHOLDER) {
                    const event = document.createEvent('HTMLEvents')
                    event.initEvent('input', true, true)
                    this._inputElements[i].dispatchEvent(event)
                }
                continue
            }

            if (this._inputValues[i] != this._inputElements[i].value) {
                const event = document.createEvent('HTMLEvents')
                event.initEvent('input', true, true)
                this._inputElements[i].dispatchEvent(event)
                continue
            }
        }
    }

    _inputChanged(element) {
        const index = this._inputElements.findIndex((e) => e == element)

        if (index >= 0) {
            if (isChromePasswordAutocompleteInitial(this._inputElements[index])) {
                // Chrome password input specific
                this._inputValues[index] = CHROME_PASSWORD_AUTOCOMPLETE_PLACEHOLDER
                return
            }

            this._inputValues[index] = this._inputElements[index].value
        }
    }

    render() {
        const {children} = this.props
        return children
    }
}

export default Autocomplete


// WEBPACK FOOTER //
// ./lib/core/components/Autocomplete.js